module.exports = __webpack_public_path__ + "static/media/elliott-group.375c77b7.png";